export default __webpack_public_path__ + "static/media/8028 - Brazy.10210528.jpeg";